import Endpoint from "../../services/api/endpoint";
import { IArticleDelivery } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IArticleDelivery>(Endpoint.ArticleDeliveries);